import { withCompController } from '@wix/editor-elements-integrations';
import { mapConsentPolicyStateRefValues } from '@wix/thunderbolt-elements/src/components/ConsentPolicyWrapper/viewer/utils';
import type {
  GoogleMapMapperProps,
  GoogleMapProps,
  GoogleMapStateRefs,
  GoogleMapControllerProps,
} from '../GoogleMap.types';
import type { ConsentPolicyControllerProps } from '@wix/thunderbolt-elements/src/components/ConsentPolicyWrapper/ConsentPolicyWrapper.types';

export const useComponentProps = ({
  stateValues,
  mapperProps,
}: {
  stateValues: GoogleMapStateRefs;
  mapperProps: GoogleMapMapperProps;
}): ConsentPolicyControllerProps & GoogleMapMapperProps => ({
  ...mapperProps,
  ...mapConsentPolicyStateRefValues(stateValues),
});

export default withCompController<
  GoogleMapMapperProps,
  GoogleMapControllerProps,
  GoogleMapProps,
  GoogleMapStateRefs
>(useComponentProps);
